









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'TreeHierarchy'
})
export default class TreeHierarchy extends Vue {
    @Prop({
        type: Object,
        required: true
    })
    node: any;

    @Prop({
        type: Boolean,
        required: false,
        default: false
    })
    onlyRow;

    @Prop({
        type: Number,
        required: false,
        default: false
    })
    level;
}
